export default __webpack_public_path__ + "static/media/logo-dfy.792fca07.png";